<template>
  <div class="attribute-item-row my-3">
    <div
      v-for="attribute in displayItems"
      :key="attribute.key"
      class="attribute-item pa-3"
    >
      <div class="attribute-item-title">
        {{ attribute.displayName }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ attribute.formatter? attribute.formatter(requestInfo[attribute.key]):requestInfo[attribute.key] }}
      </div>
    </div>
  </div>
</template>

<script>
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'RequestSummary',
  components: {},
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
    isSubRequest: {
      type: Boolean,
      default: false,
    },
  },
  data() { return { toHijriDate }; },
  computed: {
    mainRequestHeaders() {
      return [
        {
          key: 'code',
          displayName: this.local.bankruptcy.bankruptcyFile.requestCode,
        },
        {
          key: 'creationDate',
          displayName: this.local.bankruptcy.bankruptcyFile.requestDate,
          formatter: toHijriDate,
        },
        {
          key: 'legalCapacityName',
          displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
        },
        {
          key: 'requestOwnerTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
        },
        {
          key: 'bankruptName',
          displayName: this.local.bankruptcy.bankruptcyFile.bankruptName,
        },
        {
          key: 'requestCategoryName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestCategoryName,
        },
        {
          key: 'procedureName',
          displayName: this.local.bankruptcy.bankruptcyFile.procedureName,
          formatter: () => `${this.local.bankruptcy.bankruptcyFile.request} ${this.requestInfo.requestCategoryName} ${this.requestInfo.procedureName}`,
        },
        {
          key: 'requestStatusName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestStatusName,
        },

      ];
    },
    subRequestHeaders() {
      return [
        {
          key: 'code',
          displayName: this.local.bankruptcy.bankruptcyFile.subRequestCode,
        },
        {
          key: 'creationDate',
          displayName: this.local.bankruptcy.bankruptcyFile.requestDate,
          formatter: toHijriDate,
        },
        {
          key: 'legalCapacityName',
          displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
        },
        {
          key: 'requestOwnerTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
        },
        {
          key: 'debtorName',
          displayName: this.local.bankruptcy.bankruptcyFile.bankruptName,
        },
        {
          key: 'subRequestTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestType,
        },
        {
          key: 'subRequestStatusName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestStatusName,
        },
      ];
    },
    displayItems() {
      return (this.isSubRequest ? this.subRequestHeaders : this.mainRequestHeaders).map((prop) => {
        prop.value = this.requestInfo[prop.key];
        return prop;
      }).filter(item => item.value);
    },
  },
  watch: {},
  mounted() { },
  methods: {},

};
</script>

<style lang="scss" scoped>
.attribute-item-row .attribute-item:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
  border: 1px solid #dbdbdb;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}
</style>
